import { isNativePlatform } from "@/lib/platform";

/**
 * App Store compliance gate.
 *
 * The iOS/Android app must contain NO purchase, upgrade, downgrade,
 * plan-change, subscribe, pricing CTA or external-checkout path. Every
 * component that can start (or advertise) a paid flow must render its
 * informational fallback when `purchasesEnabled()` is false.
 *
 * On web this always returns true, so nothing changes for the website.
 */
export function purchasesEnabled(): boolean {
  return !isNativePlatform();
}

/** Copy shown in place of any purchase CTA inside the native app. */
export const NATIVE_BILLING_NOTICE =
  "Subscription and plan changes aren't available in the app. Your current plan is shown here for reference — contact support if you need help with your account.";
